var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSortIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99991 3.19877L6.66591 5L6 4.3756L8.5 1L11 4.3756L10.3341 5L8.99991 3.19854V11H7.99991V3.19877Z",
    fill: "#32373E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99991 8.80146L5.33409 7L6 7.6244L3.5 11L1 7.6244L1.66591 7L2.99991 8.80122V1H3.99991V8.80146Z",
    fill: "#32373E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSortIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sort-icon.6d531f8efa91e4a92150b52d8f6b6ec2.svg";